//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import { commonService } from "../../_services";
import config from '../../config';
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import { contestsActions, categoryActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
    },
    actionRoot: {
        margin: 0,
        padding: theme.spacing(1)
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    tableImg: {
        width: '50px',
        height: '50px',
        position: 'relative',
        padding: '3px'
    },

    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    },
    borderedImgTable: {
        position: 'relative',
        width: '52px',
        height: '52px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '8px',
        marginRight: '8px'
    }
});

class Contests extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            contests: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            contestAdd: false,
            title: '',
            contestError: '',
            contestSuccess: '',
            getContestsList: [],
            addContest: false,
            contestImage: '',
            perPage: config.perPageData,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the contests data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(contestsActions.getContestsList(apiConstants.GET_CONTESTS, postData));

    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        const { dispatch } = props;
        if (props.deleteContest.deleteContest !== undefined &&
            props.deleteContest.deleteContest.data !== undefined &&
            props.deleteContest.deleteContest.data.data !== undefined &&
            props.deleteContest.deleteContest.data.success === true) {

            if (this.state.triggerDelete === true) {

                this.setState({ triggerDelete: false });
                this.setState({ deletingContest: '', openDeleteCat: false });

                let postData = {};
                postData.page = this.state.currentPage;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;
                dispatch(contestsActions.getContestsList(apiConstants.GET_CONTESTS, postData));
            }
        }

        //check if contest already exist with same name
        if (
            props.saveContest !== undefined &&
            props.saveContest.savedContest !== undefined &&
            props.saveContest.savedContest === false
        ) {
            this.setState({ contestError: 'contest with same name already exist!!', contestSuccess: '', contestImage_error: '', contestDescriptionError: '' })
        }

        //IF contest ADDED SUCCESSFULLY
        if (
            props.saveContest !== undefined &&
            props.saveContest.savedContest !== undefined &&
            props.saveContest.savedContest.data !== undefined &&
            props.saveContest.savedContest.data.success !== undefined &&
            props.saveContest.savedContest.data.success === true
        ) {
            const thisHolder = this;
            if (thisHolder.state.addContest === true) {
                this.setState({ contestSuccess: 'contest added successfully!!', contestError: '', contestImage_error: '', contestDescriptionError: '' });

                setTimeout(function () {

                    thisHolder.setState({ contestSuccess: '', contestError: '', contestImage_error: '', contestDescriptionError: '' });
                    thisHolder.closeAddCatPop();

                    let postData = {};
                    postData.page = thisHolder.state.currentPage;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = thisHolder.state.perPage;
                    dispatch(contestsActions.getContestsList(apiConstants.GET_CONTESTS, postData));
                }, 2000);
            }
        }

        // GET LIST OF IDEA LIST SUCCESS
        if (props.getContestsList !== undefined &&
            props.getContestsList.getContestsList !== undefined &&
            props.getContestsList.getContestsList.data !== undefined
        ) {
            const contestDataReceived = props.getContestsList.getContestsList.data;
            this.setState({
                getContestsList: contestDataReceived,
                totalPage: contestDataReceived.pagination.totalPages,
                totalDataCount: contestDataReceived.pagination.totalCount,
            })
        }

    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });
        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;
        dispatch(contestsActions.getContestsList(apiConstants.GET_CONTESTS, postData));
    }


    //remove image while editing a category
    removeMainImage = () => { this.setState({ editingCatLogo: '' }); }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (contests, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddShopkeeper' })
        }
        //this.setState({ contests, [type]: true })
    };


    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            contests: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    //on change set category title to state
    onChangeCatTitle = (e) => {
        if (e.target.type === "file") {

            var extArr = ["image/jpeg", "image/jpg", "image/png"];
            const files = e.target.files;
            const target = e.target;
            var forimgState = [target.name + "_error"];


            if (extArr.indexOf(files[0].type) > -1) {

                this.setState({ [target.name]: files[0] });
            } else {
                this.setState({ [forimgState]: "One of the file type not suported" })
                e.target.value = null;
                this.setState({ [e.target.name]: '' })
            }
        }
        else { this.setState({ [e.target.name]: e.target.value }); }
    }

    //close add category popup
    closeAddCatPop = () => {
        this.setState({
            contestSuccess: '',
            contestAdd: false,
            title: '',
            addContest: false
        });
    }


    //save contest to collection
    handleSubmit = () => {
        const { dispatch } = this.props;
        this.setState({ contestError: '', contestImage_error: '', contestDescriptionError: '' });
        const { title, contestImage, description } = this.state;
        if (title === undefined || title === '') { this.setState({ contestError: 'contest title required!!' }) }
        else if (description === undefined || description === '') { this.setState({ contestDescriptionError: 'contest decription required!!' }) }
        else if (contestImage === undefined || contestImage === '') { this.setState({ contestImage_error: 'contest Image required!!' }) }
        else {

            this.setState({ contestError: '', addContest: true, contestImage_error: '', contestDescriptionError: '' })

            const postData = {};
            postData.title = title;
            postData.description = description;
            //postData.contestImage = contestImage;


            //add to form data to send over api
            const logoImage = new FormData();
            logoImage.append('contestImage', contestImage);

            commonService.withTokenAndFormData(apiConstants.SAVE_CONTEST_IMAGE, logoImage).then(
                res => {
                    //get image title from response
                    if (res.data !== undefined && res.data.data !== undefined) {
                        postData.contest_image = res.data.data;
                    }
                    // save contest data to cololection
                    dispatch(contestsActions.saveContest(apiConstants.SAVE_CONTESTS, postData));
                },
                error => { }
            );
        }
    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    openAddCategory = () => {
        this.setState({
            contestAdd: !this.state.contestAdd,
            contestSuccess: '',
            title: '',
            parentcat: '',
            contestImage: '',
            contestImage_error: '',
            addContest: false
        });

    }

    // handleClose = () => {
    //     this.setState({ contestAdd: !this.state.contestAdd })
    // };


    deletePopupOpen = (contestId) => {
        this.setState({ deletingContest: contestId, openDeleteCat: true });
    }

    closeDeletePopup = (contestId) => {
        this.setState({ deletingContest: '', openDeleteCat: false });
    }

    // after conform click to delete contest
    deletingCatRecord = () => {
        this.setState({ triggerDelete: true });

        const { dispatch } = this.props;
        const postData = {};
        postData.contestId = this.state.deletingContest;
        dispatch(contestsActions.deleteContest(apiConstants.DELETE_CONTEST, postData));
    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { classes } = this.props;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    Contest
                                </li>
                                <li style={{ paddingLeft: "800px" }}>
                                    <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">Contest</h1>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddCategory()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">

                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_TITLE}</th>
                                                    <th>{siteConstants.GEN_DESCRIPTION}</th>
                                                    <th>{siteConstants.GEN_IMAGE}</th>
                                                    <th scope="col" width="10%">{siteConstants.LABEL_STATUS}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.getContestsList.data != undefined &&
                                                        this.state.getContestsList.data.length > 0 ?
                                                        this.state.getContestsList.data.map((thiscontest, index) => {
                                                            let stText = 'Active';
                                                            if (thiscontest.status === 0) { stText = 'Deactive'; }

                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thiscontest.title}</td>
                                                                    <td> {thiscontest.description}</td>
                                                                    <td>
                                                                        {
                                                                            thiscontest.contest_image !== undefined && thiscontest.contest_image ? (
                                                                                <div className={classes.borderedImgTable}>
                                                                                    <img src={`${config.imgPath}` + '/uploads/contests/' + thiscontest.contest_image} className={classes.tableImg} />
                                                                                </div>
                                                                            ) : '--'
                                                                        }

                                                                    </td>

                                                                    <td>{stText}</td>
                                                                    <td>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.deletePopupOpen(thiscontest._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="6" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add contest popup */}
                    <Dialog
                        open={this.state.contestAdd}
                        aria-labelledby="contest-title"
                        aria-describedby="save-contest-description"
                    >
                        <DialogTitle id="crop-image-dialog-title" className={classes.root}>Contest</DialogTitle>
                        <DialogContent className={classes.contentRoot}>
                            <div class="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.GEN_TITLE}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder={siteConstants.GEN_TITLE}
                                            className="form-control"
                                            name="title"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.contestError}</p>
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.GEN_DESCRIPTION}</label>
                                        <textarea
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            className="form-control"
                                            name="description"
                                        >
                                        {siteConstants.GEN_DESCRIPTION}
                                        </textarea>
                                        <p style={{ color: 'red' }}>{this.state.contestDescriptionError}</p>
                                    </div>
                                </div>


                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_CONTEST_IMAGE}</label>
                                        <input
                                            type="file"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            className="form-control"
                                            name="contestImage"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.contestImage_error}</p>
                                        <p style={{ color: 'green' }}>{this.state.contestSuccess}</p>
                                    </div>
                                </div>




                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeAddCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* edit contest popup */}


                    {/* add banner popup */}
                    {/* notify about delete */}
                    <Dialog open={this.state.openDeleteCat} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>
                            {siteConstants.BTN_DELETE}
                        </DialogTitle>
                        <DialogContent>
                            {siteConstants.LABEL_SURE_DELTE_TAX_RECORD}
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingCatRecord(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>


                    <Footer />
                </div>



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, saveContest, getContestsList, addContest, deleteContest } = state;
    return {
        language,
        saveContest,
        getContestsList,
        addContest,
        deleteContest
    };
}

export default connect(mapStateToProps)(withStyles(styles)(Contests));
